import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges  } from '@angular/core';

@Component({
    selector: 'pme-timer-formatter',
    templateUrl: './timer-formatter.component.html',
    styleUrls: ['./timer-formatter.component.scss'],
    standalone: false
})
export class TimerFormatterComponent implements OnInit, OnChanges {

    constructor() { }

    @Input() seconds: number = 1800;
    @Output() notifySecondsRemaining = new EventEmitter<any>();
    @Output() onTimerComplete: EventEmitter<any> = new EventEmitter<any>();
    @Output() onStart: EventEmitter<any> = new EventEmitter<any>();
    timeRemainingString: string = '--:--';
    internalTimer: ReturnType<typeof setInterval>;

    ngOnInit(): void {
        this.startCountdownTimer(this.seconds);
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.seconds && changes.seconds.currentValue && changes.seconds.currentValue > 0) {
            this.startCountdownTimer(this.seconds);
        }
    }

    startCountdownTimer(setSeconds: number) {
        clearInterval(this.internalTimer);
        this.onStart.emit();
        this.internalTimer = setInterval(() => {
            this.notifySecondsRemaining.emit(setSeconds);
            const dateObj = new Date(setSeconds * 1000);
            // const hours = dateObj.getUTCHours();
            const minutes = dateObj.getUTCMinutes();
            const seconds = dateObj.getSeconds();

            if (setSeconds < 0) {
                this.onTimerComplete.emit();
                clearInterval(this.internalTimer);
                return;
            }

            // const formatHours = hours.toString().padStart(2, '0');
            const formatMinutes = minutes.toString().padStart(2, '0');
            const formatSeconds = seconds.toString().padStart(2, '0');

            // this.timeRemainingString = `${formatHours}:${formatMinutes}:${formatSeconds}`;
            this.timeRemainingString = `${formatMinutes}:${formatSeconds}`;
            setSeconds--;
        }, 1000);
    }


    // startCountdownTimer(setSeconds: number) {
    //     clearInterval(this.internalTimer);
    //     this.internalTimer = setInterval(() => {
    //         this.notifySecondsRemaining.emit(setSeconds);
    //         const dateObj = new Date(setSeconds * 1000);
    //         const minutes = dateObj.getUTCMinutes();
    //         const seconds = dateObj.getSeconds();
    
    //         if (setSeconds <= 0) {
    //             clearInterval(this.internalTimer);
    //             this.notifyTimerComplete.emit();
    //             return;
    //         }
    
    //         const formatMinutes = minutes.toString().padStart(2, '0');
    //         const formatSeconds = seconds.toString().padStart(2, '0');
    
    //         this.timeRemainingString = `${formatMinutes}:${formatSeconds}`;
    //         setSeconds--;
    //     }, 1000);
    // }
}